var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSearchicon = function SvgSearchicon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "m11.467 10.457 2.844 2.848a.356.356 0 0 1-.014.491l-.498.499a.355.355 0 0 1-.505 0l-2.844-2.848a1.85 1.85 0 0 1-.214-.256l-.533-.712a4.974 4.974 0 0 1-3.107 1.089 4.986 4.986 0 0 1-2.17-9.477 4.974 4.974 0 0 1 6.056 1.402 4.988 4.988 0 0 1-.032 6.224l.71.491c.112.071.214.155.307.25ZM3.04 6.584a3.553 3.553 0 1 0 7.111 0 3.558 3.558 0 0 0-3.556-3.56 3.558 3.558 0 0 0-3.555 3.56Z",
    clipRule: "evenodd"
  })));
};
export default SvgSearchicon;